export * from './ts-types';

export * from './theme';
export * from './hooks';

// Layout Components
export { default as ContentSection } from './components/layout/ContentSection';
export { default as Margin } from './components/layout/Margin';
export { default as Spacer } from './components/layout/Spacer';

// Display components
export { default as Accordion } from './components/display/Accordion';
export { default as Article } from './components/display/Article';
export { default as AsyncIndicator } from './components/display/AsyncIndicator';
export { default as Avatar } from './components/display/Avatar';
export { default as FloatingBox } from './components/display/FloatingBox';
export { default as Heading, HeadingLevel } from './components/display/Heading';
export {
  default as Icon,
  iconsMap,
  iconNames,
} from './components/display/Icon';
import {
  IconProps as _IconProps,
  IconName as _IconName,
  iconsMap,
} from './components/display/Icon';
export const iconMap = iconsMap;
export type IconProps = _IconProps;
export type IconName = _IconName;
export { default as ProgressBar } from './components/display/ProgressBar';
export { default as Spinner } from './components/display/Spinner';
export {
  SkeletonLoader,
  SkeletonBlock,
  SkeletonText,
} from './components/display/SkeletonLoader';
export { default as Surface } from './components/display/Surface';
export { default as Text } from './components/display/Text';
export { default as Tooltip } from './components/display/Tooltip';
import { TooltipPosition as _TooltipPosition } from './components/display/Tooltip';
export type TooltipPosition = _TooltipPosition;
export { default as TooltipWrapper } from './components/display/TooltipWrapper';

// Utility functions
export {
  camelCaseAriaAttrs,
  kebabCaseAriaAttrs,
} from './utils/formatAriaAttrKeys';
export { default as hashString } from './utils/hashString';
export { default as createUniqueClassName } from './utils/createUniqueClassName';

// Display Components
export { default as TagLabel } from './components/display/TagLabel';
export { default as Badge } from './components/display/Badge';
import { Img, ImgProps as _ImgProps } from './components/display/Img';
export type ImgProps = _ImgProps;
export { Img };

// Navigation Components
export { default as Link } from './components/navigation/Link';
export { default as Indicator } from './components/navigation/Indicator';
export { default as LoadMoreBar } from './components/navigation/LoadMoreBar';

export {
  default as DesignSystemProvider,
  useDesignSystem,
} from './components/context/DesignSystemProvider';

export { default as Typeahead } from './components/forms/Typeahead';

import { SyntheticEvent } from 'react';

export declare const Button: React.FC<any>;
export declare const ButtonNav: React.FC<any>;
export declare const Checkbox: React.FC<any>;
export declare const Dropdown: React.FC<any>;
export declare const Field: React.FC<any>;
export declare const FormLabel: React.FC<any>;
export declare const IconButton: React.FC<any>;
export declare const Input: React.FC<any>;
export declare const Menu: React.FC<any>;
export declare const MenuItem: React.FC<any>;
export declare const Nav: React.FC<any>;
export declare const Radio: React.FC<any>;
export declare const TextInput: React.FC<any>;
export declare const FloatingMenu: React.FC<any>;

export declare type InputEvent = SyntheticEvent<Element>;

export declare type OnDropdownBlurMetadata = {
  /**
   * Did the blur occur within the dropdown control?
   * i.e. is some child of the Dropdown still focused?
   */
  didBlurWithin: boolean;
  /**
   * Close the menu
   */
  closeMenu: () => void;
};

export declare type FloatingMenuProps = {
  /**
   * Accessibility label that describes the options available inside the select
   * menu, e.g. "List of items", "List of Countries", etc.
   */
  ariaLabel: string;
  /**
   * Callback that should be passed to the menu root element. Provided by
   * Downshift.
   */
  getMenuProps: (options: { 'aria-label': string }) => any;
  /**
   * Callback that should be passed to each menu item. Provided by Downshift.
   */
  getItemProps: (options: { item: any }) => any;
  /**
   * Callback that will be used to generate the react `key` to be used for each
   * item on the menu list.
   */
  getKeyForItem?: (item: any) => string;
  /**
   * Callback that will be used to generate the string label to be rendered for each item on the menu list.
   * Defaults to a `label` property on each item object.
   */
  getLabelForItem: (item: any) => string;
  /**
   * The menu item index that should be highlighted. Provided by Downshift.
   */
  highlightedIndex: number;
  /**
   * The list of items to display in the menu.
   */
  items: Array<any>;
  /**
   * A render prop which receives a menu `item` and the `getLabelForItem`
   * function and returns a React element, which is an icon illustrating the
   * given menu item. The natural size for the icon is 30x30px. If not
   * provided, no icons will be rendered.
   */
  renderIcon?: (
    item: any,
    getLabelForItem: (item: any) => string
  ) => React.ReactNode;
};

export declare interface FloatingMenuRenderProps extends FloatingMenuProps {
  /**
   * Action to manually select an item
   */
  selectItem: (item: any) => void;
  /**
   * The currently selected item (if any)
   */
  selectedItem: any;
  /**
   * Set the currently highlighted item index
   */
  setHighlightedIndex: (index: number) => void;
  /**
   * Clear the selection
   */
  clearSelection: () => void;
  /**
   * Close the menu
   */
  closeMenu: () => void;
}
export declare type TypographyName = string;
export declare const CopyTextInput: React.FC<any>;
